import React from 'react'
import ICSelect from 'containers/project-creation/create-view/select'
import Button from 'components/controls/button'

const TimeRange = props => {
    return (
        <div className='add-manage-time-range-container'>
            <div className='title'>{props.label}</div>
            <ICSelect
                //title={props.label}
                disabled={false}
                placeholder={props.timeHours}

                options={['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'].map(value => ({ value, label: `${value}` }))}
                value={props.timeHours}
                onChange={props.onChangeHours}
                showErrors={props.showErrors}
                error={props.errorMessage}
                className={`${props.label === 'Start Time' ? 'start-time-' : ''}hours`}
            />
            <div className='two-points-separator'> : </div>
            <ICSelect
                disabled={false}
                placeholder={props.timeMinutes}
                options={['00', '15', '30', '45'].map(value => ({ value, label: `${value}` }))}
                value={props.timeMinutes}
                onChange={props.onChangeMinutes}
                className={'minutes'}
                showErrors={props.showErrors}
                error={'hide-me'}
            />
            <div className='am-pm-tpggle'>
                <Button className={`time-am-toggle ${props.selectedToggle === 0 ? 'selected' : ''}`} onClick={() => props.onToggle(0)}>AM</Button>
            </div>
            <Button className={`time-pm-toggle ${props.selectedToggle === 1 ? 'selected' : ''}`} onClick={() => props.onToggle(1)} >PM</Button>
        </div>
    )
}

export default TimeRange
